import { render, staticRenderFns } from "./CardLink.vue?vue&type=template&id=3d1c2296&scoped=true&lang=pug&"
import script from "./CardLink.vue?vue&type=script&lang=js&"
export * from "./CardLink.vue?vue&type=script&lang=js&"
import style0 from "./CardLink.vue?vue&type=style&index=0&id=3d1c2296&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1c2296",
  null
  
)

export default component.exports